import { getSwimmersDiary } from "@/http/swimmersDiaryApi";
import { getCookie } from "@/utils/cookies";
import { getSwimmersDiaryQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetSwimmersDiaryQuery = (
  clientData,
  isClientPending,
  name: string,
  user_id: string
) => {
  const phone = getCookie("phone")?.replace("+", "") || "";
  return useQuery({
    queryKey: [getSwimmersDiaryQueryKey(), clientData],
    queryFn: () => getSwimmersDiary(phone, name, user_id),
    select: (response) => {
      if (!response) {
        // console.error("No data in response:", response);
        return [];
      }
      return response.achievements;
    },
    enabled: !!clientData && !isClientPending,
  });
};
